import { BridgeOriginError } from "./errors";
import { isExpectedOrigin as contractIsExpectedOrigin } from "./contract";

export function resolveHostOrigin(explicit?: string): string {
    if (isUsableOrigin(explicit)) return explicit as string;

    const ancestor = readAncestorOrigin();
    if (isUsableOrigin(ancestor)) return ancestor as string;

    const referrer = readReferrerOrigin();
    if (isUsableOrigin(referrer)) return referrer as string;

    throw new BridgeOriginError(
        "Unable to resolve host origin: no hostOrigin option was supplied, and neither location.ancestorOrigins nor document.referrer yielded one."
    );
}

export function isExpectedOrigin(origin: string | null, expected: string | null): boolean {
    return contractIsExpectedOrigin(origin, expected);
}

function isUsableOrigin(origin: string | null | undefined): boolean {
    // Reject the opaque "null" origin from a sandboxed frame the same way
    // contract.isExpectedOrigin does on the inbound path — it must never become
    // the pinned hostOrigin for outbound postMessage.
    return typeof origin === "string" && origin.length > 0 && origin !== "*" && origin !== "null";
}

function readAncestorOrigin(): string | null {
    try {
        const ancestors = typeof location !== "undefined" ? location.ancestorOrigins : undefined;
        if (!ancestors || ancestors.length === 0) return null;
        return ancestors.item(0);
    } catch {
        return null;
    }
}

function readReferrerOrigin(): string | null {
    try {
        if (typeof document === "undefined" || !document.referrer) return null;
        return new URL(document.referrer).origin;
    } catch {
        return null;
    }
}
